import React, { useEffect } from 'react';
import { Grid, Card, CardActionArea, CardContent, Typography, } from '@mui/material';



// function Redemption(data) {
//   let redemptionData = [];
// 
//   if (data !== undefined) {
//     redemptionData.push(
//       <Grid container style={{
//         justifyContent: "center",
//         border: 1,
//         borderRadius: 30,
//         backgroundColor: "orange",
//         padding: 5,

//       }}>
//         {data.map((value) => (
//           <Grid key={value} item>
//             {value === "Exchange" ?
//               <Tooltip title={value}>
//                 <Grid style={{
//                   margin: 5
//                 }}>
//                   <span className="material-icons">
//                     currency_exchange
//                   </span>
//                 </Grid>
//               </Tooltip>
//               : value === "Gift" ?
//                 <Tooltip title={value}>
//                   <Grid style={{
//                     margin: 5
//                   }}>
//                     <span className="material-icons">
//                       card_giftcard
//                     </span>
//                   </Grid>
//                 </Tooltip>
//                 :
//                 <Tooltip title={value}>
//                   <Grid style={{
//                     margin: 5
//                   }}>
//                     <span className="material-icons">
//                       card_membership
//                     </span>
//                   </Grid>
//                 </Tooltip>

//             }

//           </Grid>
//         ))}
//       </Grid>
//     )
//   }

//   return redemptionData;
// }

function Programdata(data,isEvent) {

  let returnTableBody = [];
  for (let index = 0; index < data.length; index++) {
    returnTableBody.push(
      <div className='card' key={index}>
        <Card
          key={index}
          variant='outlined'
          style={{
            borderRadius: 30,
            marginTop: 20,
            marginLeft: 20,
            marginRight: 20,
            outlineColor: 'black',
          }}

          onClick={()=>{
            isEvent?(window.location.href = `/event/${data[index].eventId}`)
            :(window.location.href = `/program/${data[index].ProgramId}`)
          }}
        >
          <CardActionArea>
            <CardContent style={{ fontFamily: 'Raleway' }}>
              <Grid container>
                <Grid item xs={9} sm={9} md={9}>
                  <Grid container>
                    <Grid item xs={7} md={9}>
                      <Typography
                        component='h1'
                        style={{
                          fontSize: 22,
                          fontFamily: 'Raleway',
                        }}
                      >
                        {isEvent? <strong>{data[index].eventName}</strong>
                        :<strong>{data[index].ProgramName}</strong>}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        component='h5'
                        style={{
                          color: 'black',
                          fontFamily: 'Raleway',
                        }}
                      >
                        Description: {isEvent? data[index].eventDescription
                        :data[index].ProgramDescription}
                       
                      </Typography>
                    </Grid>
                    <Grid item xs={12}></Grid>
                    <Grid item xs={12}>
                      <Typography
                        component='h5'
                        style={{
                          color: 'black',
                          fontFamily: 'Raleway',
                        }}
                      >
                         Start Date: {isEvent? data[index].startDate
                         :data[index].StartDate}
                      </Typography>
                    </Grid>
                    <Grid item xs={11}>
                      <Typography
                        component='h5'
                        style={{
                          color: 'black',
                          fontFamily: 'Raleway',
                        }}
                      >
                       Founder: {isEvent? data[index].founderName
                       :data[index].FounderName} 
                      </Typography>
                    </Grid>

                  </Grid>
                </Grid>

                {/* <Grid xs={3} sm={3} md={3} >
                   {Redemption(data[index].Redemption)}
                  </Grid> */}


              </Grid>
            </CardContent>
          </CardActionArea>
        </Card>
        <Grid item xs={12}></Grid>
        <Grid
          item
          xs={12}
          md={4}
          style={{
            display: 'inline-flex',
            float: 'right',
          }}
        ></Grid>
      </div>

    );
  }
  return returnTableBody;
}

export default function ProgramDisplayer(props) {

  useEffect(() => {
    //console.log(props.data);
  }, [])
  // useEffect(() => {
  //   const token = localStorage.getItem('token');
  //   const userID = parseInt(localStorage.getItem('userID'));

  //   let endPoint =  `/api/programs/view?user_id=${userID}`
  //   if(props.type === 2){
  //     endPoint =   `/api/programs/list/view`
  //   }

  //   fetch(process.env.REACT_APP_API_URL + endPoint, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: `Token ${token}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //      //console.log('data.response.response_data');
  //      //console.log(data.response.response_data);
  //       setAct(data.response.response_data);
  //     })
  //     .catch((err) => {
  //      //console.log(err);
  //     });
  // }, []);
  if (props.data) {
    return (
      <Grid container style={{}}>
        <Grid item md={3}></Grid>
        <Grid item xs={12} md={6}>
          {Programdata(props.data,props.isEvent)}
        </Grid>
      </Grid>
    );
  }
}
/*
if(props){
    if (props.data[0].message==undefined && props.data[0].message !="No data found for the provided data") {
      return (
        <Grid container style={{}}>
         
          <Grid item xs={12} md={6}>
            {programdata(props.data)}
          </Grid>
        </Grid>
      );
    }else{
      return (
        <Grid container style={{}}>
          <Grid item md={3}></Grid>
          <Grid item xs={12} md={6}>
          <Card
              variant='outlined'
              style={{
                borderRadius: 30,
                marginTop: 20,
                marginLeft: 20,
                marginRight: 20,
                outlineColor: 'black',
              }}
               
            >
                <Typography
                        component='h1'
                        style={{
                          fontSize: 22,
                          fontFamily: 'Raleway',
                        }}
                      >
                      No Porgram found
                      </Typography>
              </Card>
          </Grid>
        </Grid>
      );
    }
  }

}
*/